import { render, staticRenderFns } from "./PausaCaffe.vue?vue&type=template&id=b6675440&scoped=true&"
import script from "./PausaCaffe.vue?vue&type=script&lang=js&"
export * from "./PausaCaffe.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6675440",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Attivita\\SVILUPPO Laravel\\archilogy\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b6675440')) {
      api.createRecord('b6675440', component.options)
    } else {
      api.reload('b6675440', component.options)
    }
    module.hot.accept("./PausaCaffe.vue?vue&type=template&id=b6675440&scoped=true&", function () {
      api.rerender('b6675440', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/PausaCaffe.vue"
export default component.exports